import { WorldMap_worldMap } from 'graphql/query/__generated__/WorldMap';
import { IWorldMarker } from 'react-give-me-map';

export interface AddMarkerHistoryRecord {
    recordId: string;
    operation: 'add';
    data: IWorldMarker;
}

export interface UpdateMarkerHistoryRecord {
    recordId: string;
    operation: 'update';
    data: IWorldMarker;
    previousData: IWorldMarker;
    props: string[];
}

export interface DeleteMarkerHistoryRecord {
    recordId: string;
    operation: 'delete';
    data: IWorldMarker;
}

interface MarkerOrder {
    worldMapMarkerId: string;
    order: number;
}

export interface ReorderMarkersHistoryRecord {
    recordId: string;
    operation: 'reorder';
    data: MarkerOrder[];
    previousData: MarkerOrder[];
}

export interface UpdateMapRecord {
    recordId: string;
    operation: 'updateMap';
    data: Partial<WorldMap_worldMap>;
    previousData: Partial<WorldMap_worldMap>;
}

export type MarkerHistoryRecord =
    | AddMarkerHistoryRecord
    | UpdateMarkerHistoryRecord
    | DeleteMarkerHistoryRecord;

export type HistoryRecord = MarkerHistoryRecord | ReorderMarkersHistoryRecord | UpdateMapRecord;

export const isMarkerHistoryRecord = (record: HistoryRecord): record is MarkerHistoryRecord =>
    record.operation === 'add' || record.operation === 'update' || record.operation === 'delete';

export const isReorderMarkersHistoryRecord = (
    record: HistoryRecord
): record is ReorderMarkersHistoryRecord => record.operation === 'reorder';
